module.exports = __webpack_public_path__ + "img/234.eb245e68.jpg";